module.exports = __webpack_public_path__ + "static/smu_logo-e4e8acc1996c35be0f50dead91d6c27a.jpg";